module.exports = __webpack_public_path__ + "static/media/business-plan.03f6e7ca.png";